// @ts-nocheck
// update event modal
import React from "react";
import { Modal, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";

// utils
import PropTypes from "prop-types";
import ContactInformationTab from "./ContactInformationTab";
import EditEventTab from "./EditEventTab";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { AddMoreClientTab } from "./AddMoreClientTab";
import EventBillingTab from "./EditBillingTab";

// NOTE: style for modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "auto",
  boxShadow: 24,
  p: 4,
  maxHeight: "98vh",
  // minWidth: "900px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  overflowY: "auto",
};

const allProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export default function EditEventModal({
  eventData,
  open,
  handleClose,
  updateEvent,
}) {
  // media query hooks...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks...

  const [tabValue, setTabValue] = React.useState(0);

  // console.log(":::EventData:::", eventData);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          width: isMediumScreen ? "95%" : "60%",
          minWidth: isMediumScreen ? "0" : "900px",
          maxWidth: "1200px",
        }}
        className="custom-scroll-design"
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          marginBottom="20px"
          sx={{
            fontSize: isSmallScreen ? "28px" : "48px",
            textAlign: "center",
          }}
        >
          Edit Event
        </Typography>
        <Box sx={{ width: "100%", marginBottom: "30px" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            TabScrollButtonProps={{
              style: {
                color: `${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
              },
            }}
            aria-label="basic tabs example"
            variant="fullWidth"
            sx={{
              width: "100%",
              border: "1px solid #D175B6",
              overflow: "hidden",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "8px",
              "& button": {
                textTransform: "none",
                width: "50%",
                color: "#D175B6",
                "&.Mui-selected": {
                  backgroundColor: "#D175B6",
                },
                "& span": {
                  display: "none",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab label="Edit Contact Information" {...allProps(0)} />
            <Tab label="Edit Event" {...allProps(1)} />
            <Tab label="Manage Clients" {...allProps(2)} />
            {eventData?.submittedBillingInfo && (
              <Tab label="Billing Details" {...allProps(3)} />
            )}
          </Tabs>

          {tabValue === 0 && (
            <ContactInformationTab
              contactData={
                eventData?.contactInformation || eventData?.contactInformationId
              }
              handleClose={handleClose}
              updateEvent={updateEvent}
              eventId={eventData?._id || eventData?.id}
              eventName={eventData?.eventName}
            />
          )}
          {tabValue === 1 && (
            <EditEventTab
              eventData={eventData}
              handleClose={handleClose}
              updateEvent={updateEvent}
            />
          )}
          {tabValue === 2 && (
            <AddMoreClientTab
              eventId={eventData?._id || eventData?.id}
              eventInfo={eventData}
              handleClose={handleClose}
              userId={eventData?.userId?._id || eventData?.userId}
            />
          )}
          {tabValue === 3 && eventData?.submittedBillingInfo && (
            <EventBillingTab
              eventId={eventData?._id || eventData?.id}
              eventInfo={eventData}
              updateEvent={updateEvent}
              handleClose={handleClose}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
}

EditEventModal.propTypes = {
  eventData: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  updateEvent: PropTypes.func.isRequired,
};